import { Contact } from "./Contact";
import {
  AdyenPaymentMethodType,
  AdyenStoredPaymentMethod,
  AllowedPaymentMethod
} from "../Transaction";
import { MultiGetChildResponse, PaymentsPartnerCountry } from "../Common";

export enum CustomerMappingSource {
  Auto = "auto",
  Manual = "manual"
}

export enum CustomerOrigin {
  Quickbooks = "quickbooks",
  Xero = "xero",
  ZomentumGrow = "zomentum_grow"
}

export interface Customer {
  id: number;
  name: string;
  origin: CustomerOrigin;
  mapping_source?: CustomerMappingSource;
  payments_grow_customer_id?: number | null;
  reminder_enabled_date?: Date | null;
  auto_collection_enabled_date?: Date | null;
  open_invoices_count?: number | null;
  overdue_invoices_count?: number | null;
  preferred_payment_method_type?: AdyenPaymentMethodType | null;
  created_at: Date;
  updated_at: Date;
  open_invoices_total_balance?: number | null;
  overdue_invoices_total_balance?: number | null;
  country?: PaymentsPartnerCountry;
  contacts?: MultiGetChildResponse<Contact>;
  whitelists?: MultiGetChildResponse<PaymentsClientPortalWhitelistView>;
  allowed_payment_methods?: MultiGetChildResponse<AllowedPaymentMethod>;
  available_payment_methods?: MultiGetChildResponse<AdyenStoredPaymentMethod>;
}

export interface PaymentsGrowCustomer {
  id: number;
  created_at: Date;
  updated_at: Date;
  user_id: number;
  user_email: string;
  client_company_name: string;
  user_name?: string;
  customer_id?: number;
  customer_name?: string;
}

export interface CustomerForClientPortalView {
  id: number;
  name: string;
  reminder_enabled_date?: Date;
  auto_collection_enabled_date?: Date;
  open_invoices_count?: number;
  overdue_invoices_count?: number;
  preferred_payment_method_type?: AdyenPaymentMethodType;
  created_at: Date;
  updated_at: Date;
  open_invoices_total_balance?: number;
  overdue_invoices_total_balance?: number;
}

export enum AdyenCustomerType {
  CollectibleInvoiceCustomer = "App\\Domains\\Payments\\Models\\CollectibleInvoiceCustomer",
  PaymentsGrowCustomer = "App\\Domains\\Payments\\Models\\PaymentsGrowCustomer"
}

export interface PaymentsClientPortalWhitelistView {
  id: number;
  customer_id: number;
  email_or_domain: string;
  created_at: Date;
  updated_at: Date;
}

export interface PaymentsInvoiceEmailMessageView {
  id: number;
  created_at: Date;
  updated_at: Date;
  invoice_id: number;
  subject: string;
  status: number;
  recipients: string;
  invoice_number: string;
  customer_id: number;
}
